import React from 'react';
import forIn from 'lodash/forIn';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import GallerySimilar from './GallerySimilar';
import {
  makeSelectQuery,
  makeSelectOtherServices,
  makeSelectLoadingOtherServices,
} from '../selectors';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import config from '~/config';
import withI18next from '~/../hocs/_withI18next';
import LocalStorage from '~/services/LocalStorage';
// import GalleryByService from '~/components/Gallery/GalleryByService';
// import GalleryByOtherService from '~/components/Gallery/GalleryByOtherService';
// import GalleryByOtherServiceIllust from '~/components/Gallery/GalleryByOtherServiceIllust';

// import NextPageButton from '~/components/NextPageButton';
// import I18nLink from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';

@withI18next()
class OtherServices extends React.Component {
  componentDidMount() {
    const { otherServices } = this.props;
    LocalStorage.otherServices = otherServices;
  }

  onSeeMore = () => {
    const { query } = this.props;

    if (query.image_token) {
      return {
        as: `/search-result?image_token=${query.image_token}`,
        query: { image_token: query.image_token },
      };
    }

    let asPath = 'page=1';
    forIn(this.props.query, (value, key) => {
      if (
        value &&
        key !== 'page' &&
        key !== 'is_tag' &&
        key !== 'clientIp' &&
        key !== 'token' &&
        key !== 'keyword'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    return {
      as: `/search/${query.keyword}?${asPath}`,
      query: { ...this.props.query, page: 1, is_tag: true },
    };
  };

  render() {
    const {
      t,
      loadingOtherServices,
      otherServices,
      query,
      lng,
      keyword,
    } = this.props;

    return (
      <div className="other-services">
        {loadingOtherServices ? (
          <LoadingSpinner />
        ) : (
          otherServices &&
          otherServices.map(({ serviceType, collection }) => {
            if (collection && collection.length !== 0)
              return (
                <div
                  key={serviceType}
                  className="container-fluid service-section"
                >
                  <div className="header-service">
                    <h2 className="service-title desktop">
                      {t(
                        `${config.getPrefix(serviceType)}_similar_photo_title`,
                        { keyword },
                      )}
                    </h2>
                    <h2 className="service-title mobile">
                      {t(`${config.getPrefix(serviceType)}_similar_photo`)}
                    </h2>
                    {/* <I18nLink
                      href={this.onSeeMore().as}
                      as={this.onSeeMore().as}
                      host={config.getSiteURL(serviceType)}
                    >
                      <>
                        <a className="link-to desktop" target="_blank">
                          {t('view_all_title', { keyword })}
                        </a>
                        <a className="link-to mobile" target="_blank">
                          {t('view_all')}
                        </a>
                      </>
                    </I18nLink> */}
                  </div>
                  {/* {!collection || collection.length === 0 ? (
                  <div
                    style={{ padding: 16 }}
                    className="text-center"
                    dangerouslySetInnerHTML={{
                      __html: t(keyConfig.get('no_result_search_page')),
                    }}
                  />
                ) : ( */}
                  {/* <GallerySimilarIllust
                    images={collection}
                    rowHeight={204}
                    prepareLoad={loadingOtherServices}
                    serviceType={serviceType}
                    t={t}
                    lng={lng}
                    keyword={keyword}
                  /> */}
                  {/* <GalleryByOtherServiceIllust
                        images={collection}
                        rowHeight={204}
                        prepareLoad={loadingOtherServices}
                        serviceType={serviceType}
                        t={t}
                      /> */}
                  <GallerySimilar
                    images={collection}
                    rowHeight={204}
                    prepareLoad={loadingOtherServices}
                    serviceType={serviceType}
                    t={t}
                    lng={lng}
                    keyword={keyword}
                    dataSearchImage={this.onSeeMore()}
                  />
                  {/* <GalleryByOtherService
                      images={collection}
                      rowHeight={204}
                      prepareLoad={loadingOtherServices}
                      serviceType={serviceType}
                    /> */}
                </div>
              );
          })
        )}
        <style jsx>
          {`
            .header-service {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: 44px;
              // background: #1b2833;
              padding: 0;
              margin-top: 12px;
            }
            .other-services {
              width: 100%;
              background: #f8f9fa;
              padding-bottom: 32px;
              z-index: 10;
              position: relative;
              overflow: hidden;
            }
            .link-to {
              text-align: center;
              color: #509bdc;
              font-size: 16px;
              font-weight: 600;
            }
            .service-section {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            .service-title {
              display: flex;
              flex-direction: row;
              align-items: center;
              font-size: 18px;
              font-weight: 600;
              color: #1b2833;
              padding: 0;
              margin: 0;
              flex: 6;
            }

            .photos-wrapper {
              margin: 16px 0;
              max-width: 100%;
            }
            .mobile {
              display: none;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .desktop {
                display: none;
              }
              .mobile {
                display: block;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  loadingOtherServices: makeSelectLoadingOtherServices(),
  otherServices: makeSelectOtherServices(),
  query: makeSelectQuery(),
});

export default connect(mapStateToProps)(OtherServices);
